import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './slices/snackbarSlice';
import navigationReducer from './slices/navigationSlice';
import licenseReducer from './slices/licenseSlice';
import qrReducer from './slices/qrSlice';
import siteReducer from './slices/siteSlice';
import userReducer from './slices/userSlice';
import orgReducer from './slices/orgSlice';
import firebaseAuthReducer from './slices/firebaseSlice';
import observationReducer from './slices/observationSlice';
import locationReducer from './slices/locationSlice';
import collectionReducer from './slices/collectionSlice';
import arImageReducer from './slices/arImageSlice';
import arVideoReducer from './slices/arVideoSlice';
import procoreReducer from './slices/procoreSlice';
import apsReducer from './slices/apsSlice';
import projectModelReducer from './slices/projectModelSlice';
import projectFileReducer from './slices/projectFileSlice';
import livekitReducer from './slices/livekitSlice';

export const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        navigations: navigationReducer,
        site: siteReducer,
        users: userReducer,
        QRData: qrReducer,
        orgs: orgReducer,
        firebaseAuth: firebaseAuthReducer,
        license: licenseReducer,
        observations: observationReducer,
        locations: locationReducer,
        collections: collectionReducer,
        arImages: arImageReducer,
        arVideos: arVideoReducer,
        procore: procoreReducer,
        aps: apsReducer,
        projectModels: projectModelReducer,
        projectFiles: projectFileReducer,
        livekit: livekitReducer,
    },
});
